import { useMemo } from 'react';

import { useClassesAssetsMap } from 'src/hooks/use-classes-assets-map.hook';
import { Asset } from 'src/interfaces/assets.types';
import { useSelectedClassSelector } from 'src/store/features';

export const useSelectedClassAssets = (): Asset[] => {
  const selectedClass = useSelectedClassSelector();

  const { classesAssetsMap, isLoading: isClassEntitlementsLoading } =
    useClassesAssetsMap();

  return useMemo(() => {
    if (isClassEntitlementsLoading || !selectedClass?.length) return [];

    if (selectedClass.length > 1) {
      return Object.values(classesAssetsMap)
        .map((classAssets) => {
          if (!classAssets) return [];

          return classAssets;
        })
        .flat();
    }

    const selectedClassAssets = classesAssetsMap[selectedClass[0]?.sourcedId];

    return selectedClassAssets ?? [];
  }, [selectedClass, classesAssetsMap, isClassEntitlementsLoading]);
};
